/* ============================================================
   MYPRIDE HERO — crossfade slideshow carousel
   Persis referensi a3ilab.com (crossfade murni + Ken Burns)
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('.mypride-hero');
  if (!root) return;

  var slides = Array.prototype.slice.call(root.querySelectorAll('.mypride-hero__slide'));
  var dotsBox = root.querySelector('.mypride-hero__dots');
  if (slides.length < 2 || !dotsBox) return;

  var idx = 0;
  var timer = null;
  var INTERVAL = 5000;
  var THRESHOLD = 60;
  var hx = null;

  /* ---- cegah native image drag ---- */
  slides.forEach(function (s) {
    s.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });

  /* ---- build dots ---- */
  slides.forEach(function (_, i) {
    var d = document.createElement('button');
    d.setAttribute('role', 'tab');
    d.setAttribute('aria-label', 'Slide ' + (i + 1));
    if (i === 0) d.classList.add('on');
    d.addEventListener('click', function () { go(i); restart(); });
    dotsBox.appendChild(d);
  });
  var dots = Array.prototype.slice.call(dotsBox.children);

  /* ---- navigation ---- */
  function go(n) {
    slides[idx].classList.remove('on');
    dots[idx].classList.remove('on');
    idx = (n + slides.length) % slides.length;
    slides[idx].classList.add('on');
    dots[idx].classList.add('on');
  }

  function restart() {
    clearInterval(timer);
    timer = setInterval(function () { go(idx + 1); }, INTERVAL);
  }
  restart();

  /* ---- swipe: deteksi arah saat lepas (persis referensi) ---- */
  root.addEventListener('pointerdown', function (e) {
    if (e.target.closest('button, a, input, textarea, select')) return;
    hx = e.clientX;
    root.classList.add('dragging');
    clearInterval(timer);
  });

  window.addEventListener('pointerup', function (e) {
    if (hx === null) return;
    var dx = e.clientX - hx;
    if (Math.abs(dx) > THRESHOLD && dx !== 0) {
      go(idx + (dx < 0 ? 1 : -1));
    }
    hx = null;
    root.classList.remove('dragging');
    restart();
  });

  /* ---- keyboard ---- */
  root.setAttribute('tabindex', '0');
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { go(idx - 1); restart(); }
    if (e.key === 'ArrowRight') { go(idx + 1); restart(); }
  });
})();
